import { useLocale } from '@/lib/next-shim'

/**
 * Returns true when the active app language is French.
 *
 * Used to gate France-only flows (e.g. ETH teleconsultation consent dialogs).
 */
export function useIsFR() {
  const locale = useLocale()
  return locale === 'fr'
}
